import React from 'react'
import styled from 'styled-components'
import { CorporateTheme, font } from '../../utils/themes';
import ContactRoleIcon from '../../assets/icons/ContactRoleIcon';
import { useTheme } from '../../middleware/ThemeContext';
import StyledText from '../../components/StyledComponents/StyledText';
import EditIcon from '../../assets/icons/EditIcon';
import StyledToolTip from '../../components/StyledComponents/StyledTooltip';
import TooltipIcon from '../../assets/icons/Tooltip';

interface RoleListBar {
    id: number;
    title: string,
    assignedUsersCount: number;
    isStandard: boolean;
    activeRole?: number | undefined;
    onClick: (id: number) => void;
    props?: React.HTMLAttributes<HTMLDivElement>;
    onEdit: (id: number) => void;
}

const RoleListBar: React.FC<RoleListBar> = ({ id, title, assignedUsersCount, isStandard, activeRole, onClick, onEdit, props }) => {
    const { theme } = useTheme();
  return (
    <RoleBar theme={theme} className={`${activeRole == id ? 'active' : ''}`} onClick={() => onClick(id)} {...props} >
        <div className='d-flex align-items-center gap-2'>
            <span className='d-flex align-items-center justify-content-cented rounded-circle' style={{ padding: '8px', backgroundColor: theme.colors.contentBackground }}>
              <ContactRoleIcon Color={theme.CorporateTheme.colors.primary} />
            </span>
            <div className='d-flex flex-column gap-1'>
              <div className='d-flex align-items-center gap-2'>
                <StyledText
                  htmlTag={'span'}
                  fontSize='14px'
                  fontWeight={500}
                  textColor={theme.CorporateTheme.colors.headerColor}
                >
                  {title}
                </StyledText>
                {isStandard ?
                  <StyledToolTip title={`${title} is a system role`} childrenClass={'ms-0'}>
                    <TooltipIcon color="#767476" />
                  </StyledToolTip>
                  : null
                }
              </div>
              
              <StyledText
                htmlTag={'span'}
                fontSize='11px'
                fontWeight={400}
                textColor={theme.CorporateTheme.colors.textSecondary}
              >
                <span style={{ fontFamily: font.lato }}>{assignedUsersCount}</span> Assigned Users
              </StyledText>
            </div>
            {/* <StyledText htmlTag={'span'} style={{ textTransform: 'capitalize' }}></StyledText> */}
        </div>
        {!isStandard &&
          <div className='action' onClick={(e) => { e.stopPropagation(); onEdit(id); }}>
            <EditIcon color={theme.CorporateTheme.colors.textSecondary} />
          </div>
        }
    </RoleBar>
  )
}

export const RoleBar = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.CorporateTheme.colors.filterBG,
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '11px 14px',
  cursor: 'pointer',
  marginBottom: '10px',

  // '.text': {
  //   fontFamily: 'Raleway, sans-serif',
  //   fontSize: '14px',
  //   fontWeight: 500,
  //   color: theme.CorporateTheme.colors.headerColor,
  //   textTransform: 'capitalize',
  // },

  '&:hover, &.active': {
    borderLeft: `4px solid ${theme.CorporateTheme.colors.primary}`,

    // '.text': {
    //   fontWeight: 600,
    //   color: theme.CorporateTheme.colors.primary,
    // },
  },
  '.action': {
    position: 'absolute',
    top: '14px',
    right: '13px',
    padding: '4px',
    borderRadius: '5px',
    display: 'flex',
    '&:hover': {
        background: 'rgba(41, 128, 185, 0.1)',
        // background: isDelete
        //   ? 'rgba(231, 76, 60, 0.1)'
        //   : 'rgba(41, 128, 185, 0.1)',
      },
  }
}));

export default RoleListBar